import { useMemo } from "react";
import { ciriOf, fotoOf, fotoQuiz, foodName, orbitRule, orbitText, organsOf, pencernaanQuiz, planetsOf, suriaQuiz, sunOf, type SainsLang } from "@jomcerdik/shared";
import { useLang } from "../../../lib/i18n";

/** The Sains games are in Bahasa Melayu for BM and in English for every other app language (EN, 中文, தமிழ்). */
export function useSains() {
  const app = useLang();
  const lang: SainsLang = app === "ms" ? "ms" : "en";
  return useMemo(() => ({
    lang,
    organs: organsOf(lang),
    planets: planetsOf(lang),
    sun: sunOf(lang),
    rule: orbitRule(lang),
    days: (d: number) => orbitText(d, lang),
    food: (id: string, ms: string) => foodName(id, ms, lang),
    pencernaan: (n: number) => pencernaanQuiz(n, Math.random, lang),
    suria: (n: number) => suriaQuiz(n, Math.random, lang),
    ciri: ciriOf(lang),
    foto: fotoOf(lang),
    fotosintesis: (n: number) => fotoQuiz(n, Math.random, lang),
  }), [lang]);
}
